export default __webpack_public_path__ + "static/media/structure.621ec723.png";